(function () {
  var modal = null;
  var sizesContainer = null;
  var activeCard = null;

  function getModal() {
    if (!modal) {
      modal = document.getElementById('js-plp-size-modal');
      sizesContainer = document.getElementById('js-plp-size-modal-sizes');
    }
    return modal;
  }

  function resetHoverBox(hoverBox) {
    if (!hoverBox) return;

    hoverBox.classList.remove('is-added');
    delete hoverBox.dataset.top;
    delete hoverBox.dataset.panty;

    hoverBox.querySelectorAll('.size-group').forEach(function (group) {
      group.classList.remove('is-complete');
    });

    hoverBox.querySelectorAll('.js-size-select').forEach(function (btn) {
      btn.classList.remove('is-selected', 'is-disabled');
      btn.disabled = false;
    });
  }

  function openModal(card) {
    var modalEl = getModal();
    var sourceBox = card.querySelector('.js-hover-size-box');

    if (!modalEl || !sizesContainer || !sourceBox) return;

    activeCard = card;
    resetHoverBox(sourceBox);

    var title = card.querySelector('.product-item-title a');
    var price = card.querySelector('.product-item-price');
    var imgBtn = card.querySelector('.js-mobile-size-btn');
    var imgEl = card.querySelector('[data-viewed-image], .product-item-image-main, .product-item-image');

    modalEl.querySelector('#js-plp-size-modal-title').textContent = imgBtn
      ? imgBtn.getAttribute('data-product-title') || (title ? title.textContent.trim() : '')
      : (title ? title.textContent.trim() : '');

    modalEl.querySelector('#js-plp-size-modal-price').innerHTML = price ? price.innerHTML : '';

    var imgSrc = imgBtn ? imgBtn.getAttribute('data-product-img') : '';
    if (!imgSrc && imgEl) {
      imgSrc = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '';
      if (imgSrc.indexOf('width=1') !== -1 && imgEl.getAttribute('data-src')) {
        imgSrc = imgEl.getAttribute('data-src').replace('width={width}', 'width=200');
      }
    }

    var modalImg = modalEl.querySelector('#js-plp-size-modal-img');
    modalImg.src = imgSrc;
    modalImg.alt = modalEl.querySelector('#js-plp-size-modal-title').textContent;

    sizesContainer.innerHTML = '';
    sizesContainer.appendChild(sourceBox.cloneNode(true));
    resetHoverBox(sizesContainer.querySelector('.js-hover-size-box'));

    modalEl.hidden = false;
    modalEl.setAttribute('aria-hidden', 'false');
    modalEl.classList.add('active');
    document.body.classList.add('plp-size-modal-open');
  }

  function closeModal() {
    var modalEl = getModal();
    if (!modalEl) return;

    modalEl.classList.remove('active');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.hidden = true;
    document.body.classList.remove('plp-size-modal-open');
    sizesContainer.innerHTML = '';
    activeCard = null;
  }

  function initPlpSizeModal() {
    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('.js-mobile-size-btn');
      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();
        openModal(openBtn.closest('.product-item-12'));
        return;
      }

      if (event.target.closest('.js-plp-size-modal-close')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });

    document.addEventListener('ajaxProduct:added', function () {
      if (getModal() && getModal().classList.contains('active')) {
        closeModal();
      }
    });
  }

  window.theme = window.theme || {};
  theme.plpSizeModal = { open: openModal, close: closeModal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlpSizeModal);
  } else {
    initPlpSizeModal();
  }
})();
